import React from "react";
import { View, Text, Button } from "ui";
import { styled, theme } from "styles";
import { Link, NavLink, withRouter, RouteComponentProps } from "react-router-dom";

interface S {
  prez?: boolean;
  login?: boolean;
  signup?: boolean;
}

class Header extends React.Component<RouteComponentProps & S, S> {
  public state: S = {
    prez: this.props.prez,
    login: this.props.login,
    signup: this.props.signup
  };

  public logo = require("assets/logo.png");

  public handlePrezClick = () => {
    this.setState(state => ({ prez: true, login: false, signup: false }));
  }

  public handleLoginClick = () => {
    this.setState(state => ({ prez: false, login: true, signup: false }));
  }

  public handleSignupClick = () => {
    this.setState(state => ({ prez: false, login: false, signup: true }));
  }

  public render = () => {
    const { location }  = this.props;
    const presentationPrefix = location.pathname === "/" ? "" : location.pathname;
    return (
      <View m={1} flexDirection="row" alignItems="center" p={2}>
        <Link to="/">
          <Image src={this.logo} />
        </Link>
        <NavButton
          bg="white"
          as={NavLink}
          to={`${presentationPrefix}/prezentare`}
          activeClassName="active"
          color="black"
        >
          <Text
            ml={1}
            mr={1}
            fontSize={4}
            fontWeight="bold"
            text-decoration="underline"
          >
            PREZENTARE
          </Text>
        </NavButton>
        <NavButton bg="white" color="black" as={NavLink} exact to="/login" activeClassName="active">
          <Text ml={1} mr={1} fontSize={4} fontWeight="bold" >
            LOGIN
          </Text>
        </NavButton>
        <NavButton
          bg="white"
          as={NavLink}
          to="/signup"
          activeClassName="active"
          color="black"
        >
          <Text ml={1} mr={1} fontSize={4} fontWeight="bold">
            CONT
          </Text>
        </NavButton>
      </View>
    );
  }
}

export default withRouter(Header);
const NavButton = styled(Button)`
text-decoration: none;

  &.active{
    ${Text}{
      color: ${theme.colors.primary};
    }
  }
  &:hover{
    ${Text}{
      color: ${theme.colors.primary};
    }
  }
} `;

const Image = styled.img`
  max-width: 6rem;
  max-height: 6rem;
  margin: 0.4rem;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/Header.tsx